<template>
  <section class="intro" id="home">
    <div class="wrapper">
      <aside>
        <h1>Hi, I'm John, <br>a UI Developer.</h1>
        <a class="email" href="mailto:johnnyyungy@gmail.com">Email me</a>
        <div class="intro-social">
          <a href="http://www.instagram.com/johnnyyungy" target="_blank">Instagram</a> /
          <a href="https://twitter.com/johnnyyungy" target="_blank">Twitter</a> /
          <a href="https://www.youtube.com/channel/UCZhsbHXGqVWHivekOiC9ofQ" target="_blank">Youtube</a> /
          <a href="https://www.facebook.com/johnnyyungy" target="_blank">Facebook</a> /
          <a href="https://linkedin.com/in/john-yung-53930945" target="_blank">LinkedIn</a>
        </div>
      </aside>
      <div class="photo"><img src="@/assets/images/me.jpg" alt="John Yung"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'IntroSection',
};
</script>
